/**
 * @generated SignedSource<<da4a901756749821ee3aee9417bc5e90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateRegionMutation$variables = {
  enabled: boolean;
  id: string;
  name: string;
};
export type UpdateRegionMutation$data = {
  readonly updateRegion: {
    readonly enabled: boolean;
    readonly id: string;
    readonly name: string;
  };
};
export type UpdateRegionMutation = {
  response: UpdateRegionMutation$data;
  variables: UpdateRegionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "enabled",
            "variableName": "enabled"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Region",
    "kind": "LinkedField",
    "name": "updateRegion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateRegionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateRegionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "7e05079774c2daa60e7fddd94b679f44",
    "id": null,
    "metadata": {},
    "name": "UpdateRegionMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateRegionMutation(\n  $id: ID!\n  $name: String!\n  $enabled: Boolean!\n) {\n  updateRegion(input: {id: $id, name: $name, enabled: $enabled}) {\n    id\n    name\n    enabled\n  }\n}\n"
  }
};
})();

(node as any).hash = "7a9f93f1f8529990d10d374b8f1646a1";

export default node;
